import React, { Component } from 'react';
import { compose } from 'recompose';
import camelize from 'camelize';
import _, { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import config from '../../../config';
import { withEditorState } from './withEditorState';
import {
  withDataLayerProductDetailPush,
  withJustInTimeProductDetail
} from '../GTM/withDataLayerProductDetail';
import { withDataLayerProductDetailView } from '../GTM/ECommerceTracking/withDataLayerProductDetailView';
import { withDataLayerAddToCart } from '../GTM/ECommerceTracking/withDataLayerAddToCart';
import { withPdpPreview } from '../../IssuuPreview/withPdpPreview';
import { withStoreDetail } from '../Providers/WithStoreDetail';
import { loadState, saveState } from '../localStorage';
import { translateRedux, getPrintboxLocale, withTranslationProvider } from '../../Common/Translations';
import { withStartProjectState } from '../../Account/Voucher/withStartProject';
import { getProductsDiscount } from '../Providers/ProductsDiscountApi';
import { voucherExpired, getAmountAfterDiscount, getCurrencyAmount, getDiscountedAmount } from '../Helpers/SlashPrice/SlashPriceHelper';
import { setProductConfigForAPPDP } from './pdpProductConfigProvider.js' // DO NOT REMOVE THIS IMPORT, it's to prevent sentry errors for PDP CTA in PBX
import slashPriceEnabled from '../Helpers/SlashPrice/SlashPriceEnabled';
import { fetchPbxProductConfigsData, retrieveProductFromProductFamily } from '../Providers/ProductConfig';
import { round, roundCurrency } from '../Helper';
import { getFreeShippingTierEligibility, showPdpFreeShippingTierBadge } from '../Providers/FreeShippingTierApi';
import { showPermanentErrorMsg } from '../ErrorMsg';
import LoginTimeoutMinutes from '../Helpers/LoginTimeoutMinutes';

class Editor extends Component {
  constructor(props) {
    super(props);
    this.initEditor = this.initEditor.bind(this);
    this.appObserverCallback = this.appObserverCallback.bind(this);
    this.processAnalyticsEvent = this.processAnalyticsEvent.bind(this);
    this.state = {
      isLoaded: false,
      slashPriceValue: 0,
      slashPriceObject: {},
      slashPriceEnabled: false,
      slashPriceApplicable: false,
      productConfig: null,
      components: {},
      showPdpFreeShippingBadge: false,
    };
    this.urlParams = queryString.parse(window.location.search);
    this.themeName = null;
    this.themePrice = null;
    this.lastUrl = window.location.href;
  }

  isRawEditor = (url) => url.includes('editor') || url.includes('projectId');
  isEditorLoggedIn = ({sessionId = ''}) => !!sessionId;

  componentWillReceiveProps(nextProps) {
    const {
      onComponentWillReceiveProps = () => {}
    } = this;
    onComponentWillReceiveProps(nextProps);
    if ( nextProps.productPageHref != this.props.productPageHref
      && this.isRawEditor(nextProps.productPageHref)
    ) {
      console.log('Stopped watching app node');
      this.appObserver.disconnect();

      if (!this.isEditorLoggedIn(nextProps)){
        this.forceLoginTimer();
      }
    }
  }

  componentWillMount() {
    if (this.props.editor.pbxScriptLoaded) {
      window.location.reload();
      return;
    }

    const script = document.createElement('script');
    script.src = config.pbxEditor;
    script.async = true;
    script.defer = true;
    script.onload = this.initEditor;
    document.body.appendChild(script);
  }

  componentDidMount() {
    const { injectPdpPreview = () => {} } = this.props;
    const appElement = document.getElementById('app');
    injectPdpPreview(appElement);

    slashPriceEnabled().then((slashConfig) => {
      this.setState({ slashPriceEnabled: slashConfig});
    })
    showPdpFreeShippingTierBadge().then((fstConfig) => this.setState({ showPdpFreeShippingBadge: fstConfig }));

    const observerConfig = {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    };

    this.appObserver = new MutationObserver(this.appObserverCallback);
    this.appObserver.observe(appElement, observerConfig);
  }

  render() {
    const {
      id = 'app',
    } = this.props;

    const { isLoaded = false } = this.state;

    const classStr = this.props.editor.hideECommerce ? 'h-100' : '';

    return (
      <div>
        <style
          dangerouslySetInnerHTML={{
            __html: `
            #app .LineLoader {
              background: url(${config.s3BucketUrl}/assets/general/preloader.gif) no-repeat center center;
              .loader-line{
                background: unset !important;
              }
            }`
          }}
        />
        <div
          className={classStr}
          {...id && { id }}
        >
          {this.props.children}
          {/* Spacing to prevent footer and header merged */}
          {!isLoaded && <div style={{
            height: '700px'
          }}> </div>}
        </div>
      </div>
    );
  }

  initEditor() {
    this.props.dispatch({
      type: 'EDITOR',
      payload: { pbxScriptLoaded: true },
    });
    const self = this;
    self.setState({ lsLoaded: true });
    const {
      projectId = '',
      sessionId = '',
      productFamilyId = '',
      moduleId = '',
      storeName,
      showPrice = true,
      currency = '',
      useIframe = false,
      tRoute,
      lang,
      startProjectVoucherCode = '',
      startProjectProductAttributes = {},
      removeVoucherCode,
      removeProductAttributes,
    } = this.props;

    let friendlyUrl = _.get(this.props.ecommerceUrlPart.split(`${window.location.protocol}//${window.location.host}`), 1);
    const ecommerceUrlPart = `${window.location.protocol}//${window.location.host}${tRoute(friendlyUrl)}`;

    printbox.authUserRequest = () => new Promise(((resolve, reject) => {
      if (!self.props.authUserRequestCalled && sessionId) {
        resolve(sessionId);
      } else {
        let userDetail = loadState('UserDetail') || null;
        if (!userDetail) {
          $('#editor-login').modal('show');
          $('#editor-login').on('hidden.bs.modal', (e) => {
            this.loginTimerIgnored = true;
            reject('User ignored login modal');
          });

          self.onComponentWillReceiveProps = ({ sessionId }) => {
            if (sessionId) {
              resolve(sessionId);
            }
          };

          this.props.dispatch({ type: 'SET_CURRENT_PAGE_NAME', payload: "editor" })
        } else {
          $.post({
            url: `${config.api}/refreshSession`,
          }).done((response) => {
            userDetail = response.data;
            saveState('UserDetail', userDetail);
            resolve(userDetail.printbox_session_id);
          }).fail((err) => {
            reject(err);
          });
        }
      }
    })).finally(() => self.props.setAuthCalled(true));

    printbox.refreshSession = printbox.authUserRequest;

    printbox.goToCartFinished = (projectId) => {
      const data = {
        printbox_project_uuid: projectId,
        printbox_family_id: productFamilyId
      };

      if (startProjectVoucherCode.length > 0) { // addStartProjectData
        data.voucher_code = startProjectVoucherCode;
        data.project_attributes = JSON.stringify(startProjectProductAttributes);

        removeVoucherCode();
        removeProductAttributes();
      }

      return new Promise(((resolve, reject) => {
        $.post({
          url: `${config.localeApi}/cart/project/`,
          data,
        }).done((response) => {
          printbox.disableExitWarning();

          const prodConfig = self.urlParams.product_config
                                ? self.urlParams.product_config
                                : (window.__pbww_cs_model__)
                                   ? window.__pbww_cs_model__.product_config_prev_id
                                   : '';
          console.log('addToCart prodConfig', prodConfig);
          if (self.props.productDetail) {
            const data = {
              currencyCode: currency,
              product: {
                id: prodConfig,
                name: self.props.productDetail.displayName,
                price: self.props.productDetail.priceNet,
                category: self.props.displayName,
                variant: prodConfig,
                quantity: 1,
              }
            }

            self.props.dataLayerAddToCart(data);
          }
          window.location = "/checkout/precartupgrade/paper/" + projectId;
          return;
        })
        .fail((err) => {
          if(err.status == 403 || err.status == 401) {
            window.location.reload(true);
            return;
          }
          showPermanentErrorMsg(err.responseJSON.errors);
          reject(err);
        });
      }));
    };

    printbox.hideECommerce = this.dispatchECommerceHidden(true);

    printbox.showECommerce = this.dispatchECommerceHidden(false);

    printbox.savingFinished = projectId => new Promise(((resolve, reject) => {
      $.ajax({
        url: `${config.localeApi}/cart/project/update`,
        type: 'PUT',
        data: {
          printbox_project_uuid: projectId,
        },
        dataType: 'json',
        success() {
          resolve(true);

          const data = {
            printbox_project_uuid: projectId,
            product_category: self.props.productDetail && self.props.productDetail.productCategory
                              ? self.props.productDetail.productCategory : "ALL",
          };
          let retrieved = loadState('ProductCategory');
          if (retrieved) {
            if (isEmpty(retrieved.find(data => data.printbox_project_uuid === projectId))) {
              retrieved.push(data);
              saveState('ProductCategory', retrieved);
            }
          } else {
            saveState('ProductCategory', [data]);
          }
        },
        error(err) {
          if(err.status == 404 && err.responseJSON.errors === 'No DS Promo details found') {
            window.location.href = '/design-service-promo?redirect_uri=/design-service-promo';
            return ;
          }
          if(err.status == 403 || err.status == 401) {
            window.location.reload(true);
            return ;
          }
          reject(err);
        },
      });
    }));

    printbox.setupExternalAnalyticsIntegration = () => {
      return {
        enablePbxCustomAnalyticsService: false,
        enablePbxIntegrationToExternalAnalyticsServices: false,
        processAnalyticsEvent: this.processAnalyticsEvent,
      }
    }

    printbox.setEditorConfig({
      ...projectId && { projectId },
      ...ecommerceUrlPart && { ecommerceUrlPart },
      productFamilyId: productFamilyId.toString(),
      moduleId: moduleId.toString(),
      storeName,
      showPrice,
      currency,
      sessionId,
      useIframe,
      language: getPrintboxLocale(lang),
      locale: getPrintboxLocale(lang)
    });
  }

  forceLoginTimer = () => {
    if (!this.loginTimer) {
      window.onbeforeunload = () => {
        printbox.refreshSession();
      }
      this.showLoginModal = true;
      const showModalRepeat = () => {
        if (this.showLoginModal) {
          this.showLoginModal = false;
          printbox.refreshSession()
          .then((session) => {
            if (session) {
              window.onbeforeunload = () => {};
              clearInterval(loginTimer);
            }
          }).catch( () => {
            this.showLoginModal = true;
          });
        }
      }
      LoginTimeoutMinutes()
      .then((minutes) => {
        this.loginTimer = setInterval(showModalRepeat, minutes);
      });
    }
  }

  appObserverCallback() {
    this.webListViewEvent();
    this.pdpUiChanges();
    this.pdpProductPathChanges();
  };

  dispatchECommerceHidden(isHidden) {
    return () => new Promise(((resolve, reject) => {
      this.props.dispatch({
        type: 'EDITOR',
        payload: { hideECommerce: isHidden },
      });
      resolve(true);
    }));
  }

  processAnalyticsEvent(event) {
    if ( event.label === 'upselling_start_step' && this.state.slashPriceApplicable) {
      this.setState( { upsellSlashPrice: true } );
      this.upsellChanges();
    }
  }

  webListViewEvent = () => {
    const url = window.location.href;
    if (url !== this.lastUrl) {
      this.lastUrl = url;

      const urlSearchParams = new URLSearchParams(window.location.search);
      const { product_config: productConfig } = Object.fromEntries(urlSearchParams.entries());

      this.sendProductDetailView(productConfig);
    }
  }

  pdpUiChanges = () => {
    let pdpPriceElement = document.querySelector('.TCCtaSelector .PriceView');
    let customHtmlSelector = '.TCCtaSelector .TC_AdditionalText';
    
    if (!pdpPriceElement) {
      pdpPriceElement = document.querySelector('.PbwwCallToAction .PriceView');
      customHtmlSelector = '.PbwwCallToAction ._customHtml';
    }

    if (pdpPriceElement && pdpPriceElement.innerText) {
      let {product_config: productConfig, paper: paper} = this.getAttributes();
      this.showFreeShippingBadge();

      if (this.state.productConfig !== productConfig) {
        this.setState({ productConfig: productConfig, components: {'paper': paper} });
        this.updateSlashPrice(pdpPriceElement, customHtmlSelector);
      } else if (this.isEligibleForSlashPrice(pdpPriceElement)) {
        const slashedPrice = this.applySlashPrice(pdpPriceElement, { textAlign: 'right' }, customHtmlSelector);
        this.setState(() => ({ slashPriceValue: slashedPrice }));
      }

    } else if (this.state.slashPriceValue > 0) {
      this.setState({ slashPriceValue: 0 });
    }
  }

  pdpProductPathChanges = () => {
    if (this.props.productPagePath !== window.location.pathname) {
      this.props.dispatch({
        type: 'PRODUCT_PAGE_PATH',
        payload: {
          productPageHref: window.location.href,
          productPagePath: window.location.pathname,
        },
      });

      this.ecommerceChanges();
    }
  }

  upsellChanges() {
    if (this.state.slashPriceApplicable) {
      const upsellInterval = setInterval(() => {
        const upsellPriceElement = document.querySelector('.price');
        if (upsellPriceElement && upsellPriceElement.innerText && this.isEligibleForSlashPrice(upsellPriceElement)) {
          this.applySlashPrice(upsellPriceElement, { fontSize: '18px' });
          clearInterval(upsellInterval);
        }
      }, 500);
    }
  }
  
  sendProductDetailView(productConfig = null) {
    fetchPbxProductConfigsData([productConfig]).done((response) => {
      const { currency } = this.props;
      const pagesElement = Array.from(document.querySelectorAll('._header')).find(query => query.textContent.toLowerCase().includes('page'));

      if (_.get(response.data, '0')) {
        const {
          product_category: productCategory,
          product_name: productName,
          product_price: price = this.themePrice
        } = response.data[0];

        let numberOfPages = null;
        let pricePerPage = null;
        if (pagesElement !== undefined) {
          numberOfPages = Number(pagesElement.nextSibling.textContent.match(/\d+/)[0]) || null;
          if (price) {
            pricePerPage = roundCurrency(price / numberOfPages);
          }
        }

        this.props.dataLayerProductDetailView({
          id: productConfig,
          currency,
          name: this.themeName,
          numberOfPages,
          price,
          pricePerPage,
          productName,
          category: productCategory,
          variant: null
        });
      }
    });
  }

  isEligibleForSlashPrice (element) {
    if (!this.state.slashPriceApplicable || !element || !element.innerText) return false;
    const [ currency, amount, currencyOnRight ] = getCurrencyAmount(element.innerText);
    if (amount == 0) return false;
    const spanNode = _.first(element.children);
    if (spanNode && spanNode.className.includes('slash-price-original-slashed')) return false;
    return !spanNode || parseFloat(amount) !== this.state.slashPriceValue;
    // comparing this element amount to slashPriceValue, the intention is to prevent infinite re-applying of slash price if changing the size does not change the price
    // But when going back and forth from PDP to category page, the slashPriceValue is still saved because it's still editor component either way
    // can not remove the check because of infinite loop, instead we just reset the value of slashPriceValue on leaving pdp and change it when it's applied
  }

  applySlashPrice (priceElement, additionalStyle, customHtmlSelector = '') {
    const {
      productFamilyId,
      t,
      store: { currency: { decimal_places: decimalPlaces } }
    } = this.props;

    const {
      discount_percentage: slashPriceDiscount,
      voucher_code: slashPriceCode,
      product_discounted_amount: discountedProductPrice,
      component_discounted_amount: discountedComponentPrice
    } = _.get(this.state.slashPriceObject, productFamilyId);
    const oldPrice = priceElement.innerText;

    const [currency, amount, currencyOnRight] = getCurrencyAmount(oldPrice);
    let amountAfterDiscount = 0;

    if (discountedProductPrice && !this.state.upsellSlashPrice) {
      let totalDiscountAmount = discountedComponentPrice ? discountedProductPrice + discountedComponentPrice : discountedProductPrice;
      amountAfterDiscount = getDiscountedAmount(amount, totalDiscountAmount, decimalPlaces);
    } else {
      const discountRate = slashPriceDiscount / 100;
      amountAfterDiscount = getAmountAfterDiscount(amount, discountRate, decimalPlaces);
    }

    const newPrice = currencyOnRight ? `${amountAfterDiscount} ${currency}` : `${currency} ${amountAfterDiscount}`;

    let elementToSlash = _.first(priceElement.children);
    if (elementToSlash.children.length) { // if it's the div not the span
      elementToSlash = _.first(elementToSlash.children);
    }
    elementToSlash.setAttribute('class', elementToSlash.className + ' slash-price-original-slashed');

    let slashPriceElement = _.first(document.querySelectorAll('.PriceView span.slash-price-appended'));
    if (!slashPriceElement) {
      slashPriceElement = document.createElement('SPAN');
    }
    slashPriceElement.textContent = newPrice;
    slashPriceElement.setAttribute('class','slash-price-appended');
    priceElement.appendChild(slashPriceElement);

    for (const [key, value] of Object.entries(additionalStyle)) {
      priceElement.style[key] = value;
    }

    const customHtmlElement = customHtmlSelector ? document.querySelector(customHtmlSelector) : null;
    if (customHtmlElement) {
      if (customHtmlSelector.includes('.TCCtaSelector')) {
        customHtmlElement.innerHTML = `<p>
        <span>
        ${t('footer.editor_slashprice_details', `Get ${slashPriceDiscount}% discount with code <strong>${slashPriceCode.toUpperCase()}</strong>.`,{discount: slashPriceDiscount, code: slashPriceCode.toUpperCase()})}
        ${t('footer.editor_slashprice_body', 'Shipping and handling not included.')}
        </span>
        </p>`;
      } else {
        customHtmlElement.innerHTML = `<p>
        <span style="color: #ff6600;"><strong>${slashPriceDiscount}% ${t('footer.editor_slashprice_off', 'OFF')}</strong></span> | \
        <span style="color: #ff6600;"><strong>"${slashPriceCode.toUpperCase()}"</strong></span>\
        <span style="color: #4a4a4a;font-size:16px"> ${t('footer.editor_slashprice_discountapplied', 'Discount Applied')}</span>
        <span style="color: #000000;">${t('footer.editor_slashprice_body', 'Shipping and handling not included.')}</span>
        </p>`;
      }
    }

    return parseFloat(amount);
  }

  async showFreeShippingBadge() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const { product_config } = Object.fromEntries(urlSearchParams.entries());
    const { showPdpFreeShippingBadge } = this.state;
    const { t, lang } = this.props;
    const imageUrl = `${config.s3BucketUrl}/assets/general/fst_truck.svg`;
    const fstText = t('footer.editor_fst_text', 'Eligible for FREE shipping.');
    const fstTextNewPdp = t('footer.editor_new_fst_text', 'Enjoy FREE SHIPPING with a minimum spend.');
    const fstLearnMore = t('footer.editor_fst_learnmore', 'Learn more');
    const fstModalButton = t('footer.freeshippingtierinfo_container_modalbuttontext', 'Okay');
    const msg = `<div style="display: flex!important; padding: 14px" class="row col ml-0 mb-4 fst-applied free-shipping-tier-badge__description">
      <img class="mr-1 free-shipping-tier-badge__image" src="${imageUrl}" />
      <p>${fstText} <a href="#" class="free-shipping-tier-badge__anchor" data-toggle="modal" data-target="#free-shipping-tier-info-modal">${fstLearnMore}</a></p>
    </div>`;
    const msgNewPdp = `<div class='TC_AdditionalItem'><div style="display: flex!important; align-items: center;" class="row p-0 col ml-0 fst-applied">
      <img class="mr-1 free-shipping-tier-badge__image" src="${imageUrl}" />
      <p>${fstTextNewPdp} <a href="#" class="free-shipping-tier-badge__anchor" data-toggle="modal" data-target="#free-shipping-tier-info-modal">${fstLearnMore}</a></p>
    </div></div>`;

    if (showPdpFreeShippingBadge) {
      if (product_config) {
        if (product_config != this.state.productConfig) {
          const { product_configs } = await getFreeShippingTierEligibility([product_config]);
          if (product_configs.length == 0) {
            $('.fst-applied').remove(); 
          } else if ($('.fst-applied').length == 0) {
            if($('.TCCtaSelector').length == 0) {
              $('.TemplatedComponent.template-pbwwCallToAction').append(msg);
            } else {
              $('.TCCtaSelector .TC_AdditionalWrapper').append(msgNewPdp);
            }
          }
        }
      } else {
        if ($('.fst-applied').length == 0) {
          if($('.TCCtaSelector').length == 0) {
            $('.TemplatedComponent.template-pbwwCallToAction').append(msg);
          } else {
            $('.TCCtaSelector .TC_AdditionalWrapper').append(msgNewPdp);
          }
          this.setState({ productConfig: product_config });
        }
      }

      if ($('#free-shipping-tier-info-modal').length === 0) {
        $($('.TCCtaSelector').length == 0 ? '.TemplatedComponent.template-pbwwCallToAction' : '.TCCtaSelector').append(`
          <div id="free-shipping-tier-info-modal" class="free-shipping-tier-info-modal modal fade" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="free-shipping-tier-info-modal__dialog modal-dialog modal-sm mx-auto" role="document">
              <div class="modal-content p-4">
                <button type="button" class="free-shipping-tier-info-modal__close-btn close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
                <div class="modal-body p-0">
                  <iframe class="free-shipping-tier-info-modal__iframe w-100 border-0" src="/${lang}/free-shipping-tier-info"></iframe>
                </div>
                <div class="modal-footer p-0 justify-content-center">
                  <button type="button" class="free-shipping-tier-info-modal__textual-close-btn btn btn-primary text-white font-weight-bold" data-dismiss="modal">${fstModalButton}</button>
                </div>
              </div>
            </div>
          </div>
        `);
      }
    }
  }

  ecommerceChanges() {
    if (this.props.productPageHref !== this.props.ecommerceUrlPart) {
      const {
        productFamilyId, displayName
      } = this.props;

      const friendlyUrlArray = this.props.productPagePath.split('/');
      const lastFriendlyUrlSegment = this.urlParams.productId ? this.urlParams.productId : _.last(friendlyUrlArray);

      this.props.dispatch({ type: 'SET_CURRENT_PAGE_NAME', payload:  "" })

      productFamilyId && lastFriendlyUrlSegment && retrieveProductFromProductFamily(productFamilyId, lastFriendlyUrlSegment).then((response) => {
        const data = camelize(response.data);
        const prodConfig = this.urlParams.product_config ? this.urlParams.product_config :
                            (window.__pbww_cs_model__) ? window.__pbww_cs_model__.product_config_prev_id : '';

        console.log('PDP View', prodConfig);
        data.productCategory = this.getProductCategory(data, friendlyUrlArray, lastFriendlyUrlSegment);

        this.props.dataLayerProductDetailPush({
          productName: data.displayName,
          priceNet: data.priceNet,
          thumbUrl: data.thumbUrl,
          identifier: data.attributeValues.theme,
          productConfig: prodConfig,
          fullFriendlyUrl: data.fullFriendlyUrl,
        });
        this.props.setProductDetail(data);

        this.themePrice = data.priceNet;
        this.themeName = data.displayName;
        if (isEmpty(prodConfig)) {
          this.props.dataLayerProductDetailView({
            id: prodConfig,
            currency: this.props.currency,
            name: data.displayName,
            price: data.priceNet,
            category: displayName,
            variant: prodConfig
          });
        } else {
          this.sendProductDetailView(prodConfig);
        }
      });
    }
  }

  getProductCategory(productData, friendlyUrlArray, lastFriendlyUrlSegment) {
    const fullFriendlyUrlArray = productData.fullFriendlyUrl.split("/");
    const categoryIndex = fullFriendlyUrlArray.findIndex(segment => segment === "");
    let friendlyUrlCategory = _.get(friendlyUrlArray, categoryIndex + 1);
    let productCategory = '';

    if (lastFriendlyUrlSegment === friendlyUrlCategory || friendlyUrlCategory === 'editor' || friendlyUrlCategory === '') {
      productCategory = "ALL";
    } else {
      const excludeFromCategory = ["-canvas", "-photo-books"];
      if (excludeFromCategory.some(word => friendlyUrlCategory.includes(word))) {
        friendlyUrlCategory = _.first(friendlyUrlCategory.split("-"));
      }
      
      productCategory = friendlyUrlCategory.replaceAll('-','').toUpperCase();
    }
    return productCategory;
  }

  updateSlashPrice(pdpPriceElement, customHtmlSelector) {
    if (this.props.productFamilyId && this.state.slashPriceEnabled) {
      getProductsDiscount([this.props.productFamilyId], this.state.productConfig, this.state.components).done(
        (slashPriceVoucher) => {
          const currentSlashPrice = _.get(slashPriceVoucher.data, this.props.productFamilyId);
          const slashPriceApplicable = currentSlashPrice && !voucherExpired(currentSlashPrice.expiry_date) ||
            (currentSlashPrice.product_discounted_amount && currentSlashPrice.product_discounted_amount > 0);

          this.setState({
            slashPriceObject: slashPriceVoucher.data,
            slashPriceApplicable: slashPriceApplicable,
          });

          const slashedPrice = this.applySlashPrice(pdpPriceElement, { textAlign: 'right' }, customHtmlSelector);
          this.setState(() => ({ slashPriceValue: slashedPrice }));
        }
      );
    }
  }

  getAttributes() {
    const urlAttributes = queryString.parse(window.location.search);
    if (urlAttributes.product_config && urlAttributes.paper) {
      return urlAttributes;
    } else if (printbox.api.v1.attributes) {
      let attributes = {};
      (printbox.api.v1.attributes.getAttributes())
        .filter(({ attributeId }) => (attributeId == 'product_config' || attributeId == 'paper'))
        .map(
          ({ attributeId, values }) => {
            values.some(({ id, isSelected }) => {
              if (isSelected) {
                attributes[attributeId] = id;
              }
            });
          }
        );
      return attributes;
    }
  }
}

Editor.PropTypes = {
  projectId: PropTypes.string,
  ecommerceUrlPart: PropTypes.string,
  productFamilyId: PropTypes.string.required,
  moduleId: PropTypes.string.required,
  storeName: PropTypes.string.required,
  currency: PropTypes.string.required,
  sessionId: PropTypes.string,
  useIframe: PropTypes.bool,
  language: PropTypes.string.required,
  locale: PropTypes.string.required,
  removeVoucherCode: PropTypes.func.isRequired,
  removeProductAttributes: PropTypes.func.isRequired,
};

export const willHideOnEditor = (WrappedComponent) => {
  class willHide extends Component {
    render() {
      return !this.props.editor.hideECommerce &&
        <WrappedComponent {...this.props}/>;
    }
  }
  return connect(state => ({ editor: state }))(willHide);
};

const enhance = compose(
  translateRedux,
  withEditorState,
  withJustInTimeProductDetail,
  withDataLayerProductDetailPush,
  withDataLayerProductDetailView,
  withDataLayerAddToCart,
  withStartProjectState,
  withPdpPreview,
  withTranslationProvider,
  withStoreDetail
);

export default enhance(Editor);
export const undecorated = Editor;



// WEBPACK FOOTER //
// ./src/Common/Editor/Editor.js